import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"dense":"","outlined":"","clearable":"","hide-details":"auto","item-text":_vm.displayName,"item-value":"id","items":_vm.items,"label":_vm.$t('Ward')},on:{"input":_vm.HandleInput},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }